import { makeStyles } from '@material-ui/core/styles';
import { primaryButtonStyle } from '../../../../shared/styles/buttons.styles';
import { redesignTheme } from '../../../../theme';

const { colors, spacing, breakpoints, fonts, fontSize, sizes } = redesignTheme;

export const useBlockToolbarStyles = makeStyles(() => ({
  blockToolbar: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
    padding: `${spacing.md}px ${spacing.sm}px`,
    borderBottom: `1px solid ${colors.tabBorder}`,
    backgroundColor: colors.background,
    flexShrink: 0,
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      gap: spacing.xs,
      padding: `${spacing.sm}px ${spacing.xs}px`,
    },
  },
  toolbarMainRow: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.lg,
    width: '100%',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      gap: spacing.sm,
    },
  },
  toolbarSubHeaderRow: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.lg,
    width: '100%',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      gap: spacing.sm,
      flexWrap: 'wrap',
    },
  },
  barEditionWrap: {
    flex: 1,
    minWidth: 0,
  },
  toolbarActionsGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.lg,
    paddingRight: spacing.lg,
    borderRight: `1px solid ${colors.tabBorder}`,
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      gap: spacing.sm,
      paddingRight: spacing.sm,
    },
  },
  toolbarLegacyIcons: {
    display: 'flex',
    alignItems: 'center',
    gap: 56,
    padding: `0 ${spacing.xl}px 0 ${spacing.xl}px`,
    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      gap: spacing.lg,
      padding: `0 ${spacing.md}px`,
    },
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      gap: spacing.sm,
      padding: 0,
    },
  },
  toolbarIconButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
  },
  toolbarLegacyIcon: {
    width: 20,
    height: 20,
    fill: colors.primaryDark,
  },
  toolbarCenter: {
    display: 'flex',
    alignItems: 'center',
    gap: 37,
    flex: 1,
    flexWrap: 'wrap',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      gap: spacing.sm,
    },
  },
  positionGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.sm,
  },
  toolbarLabel: {
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.md,
    color: colors.primaryDark,
    letterSpacing: '0.28px',
    whiteSpace: 'nowrap',
  },
  positionInput: {
    width: 48,
    height: sizes.inputHeight,
    padding: '0 8px',
    border: `1px solid ${colors.border}`,
    borderRadius: 4,
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    color: colors.text,
    textAlign: 'center',
    outline: 'none',
    '&:focus': {
      borderColor: colors.primaryDark,
    },
  },
  arrowGroup: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  arrowButton: {
    padding: 0,
    width: 16,
    height: 16,
    color: colors.primaryDark,
    cursor: 'pointer',
  },
  deleteAction: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.xs,
    padding: 0,
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.md,
    color: colors.primaryDark,
    letterSpacing: '0.28px',
  },
  deleteIcon: {
    width: 24,
    height: 24,
    fill: colors.primaryDark,
  },
  addBlockButton: {
    ...primaryButtonStyle,
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: colors.primary,
    },
  },
  blockTypeMenuWrap: {
    position: 'relative',
    flexShrink: 0,
    marginLeft: 'auto',
  },
  typeSelectorWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.xs,
    padding: '5px 8px',
    borderLeft: `1px solid ${colors.border}`,
    backgroundColor: '#ECECEC',
  },
  typeSelectorLabel: {
    fontSize: 11,
    color: colors.text,
  },
  typeSelector: {
    height: 28,
    border: `1px solid ${colors.border}`,
    borderRadius: 4,
    fontFamily: fonts.opensans,
    fontSize: fontSize.sm,
    color: colors.text,
    backgroundColor: colors.white,
  },
  okButton: {
    minWidth: 36,
    height: 28,
    padding: '4px 8px',
    marginLeft: 8,
    border: 0,
    borderRadius: 4,
    backgroundColor: colors.primaryDark,
    color: colors.white,
    fontFamily: fonts.opensans,
    fontSize: 11,
    cursor: 'pointer',
    '&:disabled': {
      backgroundColor: '#ccc',
      cursor: 'not-allowed',
    },
  },
}));
